const initialState = {
  backgroundTree: null,
}
export default initialState
